import {requestJson} from '@/ui/services/api.ts';
import {AdventureSummaryDTO, AdventureSummaryDTOSchema} from '@hexcrawl/shared-utils';
import {z} from 'zod';

export const adventureService = {
  getAdventures(level: number): Promise<AdventureSummaryDTO[]> {
    return requestJson<AdventureSummaryDTO[]>({
      url: `/adventures?level=${level}`,
      method: 'GET',
      schema: z.array(AdventureSummaryDTOSchema),
    });
  },
};
